// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xnXC0","placeholdersHeader":"styles_placeholdersHeader__3orAp","editorStyle":"styles_editorStyle__1xX0z","placeholdersBox":"styles_placeholdersBox__SMaWZ"};